export default __webpack_public_path__ + "static/media/orange.eb2e59a3.png";